import axios from 'axios';

export interface InviteNioAdminRequest {
  nioId: string;
  email: string;
}

export interface RegisterNioAdminRequest {
  token: string;
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
  position?: string;
}

export interface InviteCompanyOrgAdminRequest {
  email: string;
  companyOrganizationId: number;
}

export interface InviteNioOrgAdminRequest {
  email: string;
  ripoId: number;
}

export interface RegisterCompanyOrgAdminRequest {
  token: string;
  password: string;
  firstName: string;
  lastName: string;
  phone: string;
  position: string;
}

export interface AdminAuthRequest {
  username: string;
  password: string;
}

export default class AdminService {
  public inviteNioAdmin(request: InviteNioAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/admin/invite-nio-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public inviteNioSuperAdmin(request: InviteNioAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/admin/invite-nio-super-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public registerNioAdmin(request: RegisterNioAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/register-nio-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public registerNioSuperAdmin(request: RegisterNioAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/register-nio-super-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public adminAuthenticate(request: AdminAuthRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/admin-authenticate', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public adminLogout(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/admin-logout')
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public inviteCompanyOrgAdmin(request: InviteCompanyOrgAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/admin/invite-company-org-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public inviteNioOrgAdmin(request: InviteNioOrgAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/admin/invite-nio-organization-unit-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getNioOrganizationUnits(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get('/api/admin/nio-organization-units')
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public registerCompanyOrgAdmin(request: RegisterCompanyOrgAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/register-company-org-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public registerNioOrgAdmin(request: RegisterNioAdminRequest): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post('/api/register-nio-org-admin', request)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
